import { gql } from "@apollo/client";

export const GET_MASTER_DATA_PRODUCT_PRICES = gql`
  query MasterDataProductPrices($params: MasterDataProductPricesParamsInput!) {
    masterDataProductPrices(params: $params) {
      total
      page
      limit
      items {
        productPriceId
        productId
        productKey
        itemName
        basePrice
        startDate
        endDate
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;
